import React from 'react';

import {
  useTranslation
} from 'react-i18next';

import ScaleCombo from '@terrestris/react-geo/dist/Field/ScaleCombo/ScaleCombo';
import useMap from '@terrestris/react-geo/dist/Hook/useMap';

import {
  useAppVersion
} from '../../hooks/useAppVersion';

import './index.less';

export type FooterProps = React.ComponentProps<'div'>;

export const Footer: React.FC<Partial<FooterProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const map = useMap();
  const version = useAppVersion();

  const {
    t
  } = useTranslation();

  if (!map) {
    return <></>;
  }

  return (
    <footer
      className="footer"
      {...passThroughProps}
    >
      <div
        className="footer-scale"
      >
        <label>
          {t('Footer.scaleComboLabel')}:
        </label>
        <ScaleCombo
          map={map}
        />
      </div>
      <div
        className="footer-version"
      >
        {`${t('Footer.versionLabel')}: ${version}`}
      </div>
      <div
        className="footer-imprint"
      >
        <span>
          {
            t('Footer.imprint')
          }
        </span>
        <a href='https://wzb.eu/de/impressum'>
          {
            t('Footer.imprintLinkText')
          }
        </a>
      </div>
    </footer>
  );
};

export default Footer;
